import Component from '@glimmer/component';

import { generateWordsArray } from 'webapp/utils/common';

import makeArray from 'webapp/helpers/make-array';
import MetricLibraryGridComponent from 'webapp/components/metric-library/grid';
import MetricLibrarySourceGridItemComponent from 'webapp/components/metric-library/source/grid-item';

import type FilterSortMetricLibraryMainIntegrations from 'webapp/models-custom/filter-sort/metric-library-main-integrations';

export interface Args {
	filterSort: FilterSortMetricLibraryMainIntegrations;
	title: string;
	initialRowCount: number;
	classNames: string;
}

export default class MetricLibraryGridSourcesComponent extends Component<Args> {
	get activeFilterWords() {
		return generateWordsArray(this.args.filterSort.typedFilter.toLowerCase());
	}

	<template>
		<MetricLibraryGridComponent
			@filterSort={{@filterSort}}
			@title={{@title}}
			@initialRowCount={{@initialRowCount}}
			@classNames={{@classNames}}
			@animationProperty="id"
			as |visibleItems settings|
		>
			<ul class="flex-ct flex-ct--size-source">
				{{#each visibleItems as |model|}}
					<MetricLibrarySourceGridItemComponent
						@model={{model}}
						@activeFilterWords={{this.activeFilterWords}}
					/>
				{{/each}}

				{{! adding (max-in-line - 1) fake items so the incomplete last row items are not stretched too much }}
				{{#each (makeArray length=settings.itemsPerRow)}}
					<li class="flex-item flex-item--fake"></li>
				{{/each}}
			</ul>
		</MetricLibraryGridComponent>
	</template>
}
